import React, { useState } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { Button } from './ui/button';
import { Calendar } from './ui/calendar';
import { CalendarIcon } from 'lucide-react';
import { format } from 'date-fns';
import { pt } from 'date-fns/locale';

const PeriodFilter = ({ value, onChange, className = '' }) => {
  const [customStartDate, setCustomStartDate] = useState(null);
  const [customEndDate, setCustomEndDate] = useState(null);
  const [showCustom, setShowCustom] = useState(false);

  const periods = [
    { value: '7', label: 'Última semana' },
    { value: '15', label: 'Últimos 15 dias' },
    { value: '30', label: 'Últimos 30 dias' },
    { value: '90', label: 'Últimos 3 meses' },
    { value: '180', label: 'Últimos 6 meses' },
    { value: '365', label: 'Último ano' },
    { value: 'custom', label: 'Personalizado' },
  ];

  const handlePeriodChange = (newValue) => {
    if (newValue === 'custom') {
      setShowCustom(true);
    } else {
      setShowCustom(false);
      onChange({ type: 'preset', days: parseInt(newValue) });
    }
  };

  const handleCustomApply = () => {
    if (customStartDate && customEndDate) {
      onChange({ 
        type: 'custom', 
        startDate: customStartDate, 
        endDate: customEndDate 
      });
      setShowCustom(false);
    }
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Select value={value} onValueChange={handlePeriodChange}>
        <SelectTrigger className="w-48">
          <SelectValue placeholder="Selecionar período" />
        </SelectTrigger>
        <SelectContent>
          {periods.map((period) => (
            <SelectItem key={period.value} value={period.value}>
              {period.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {showCustom && (
        <Popover>
          <PopoverTrigger asChild>
            <Button variant="outline" className="w-64">
              <CalendarIcon className="mr-2 h-4 w-4" />
              {customStartDate && customEndDate ? (
                <>
                  {format(customStartDate, 'dd/MM/yyyy')} - {format(customEndDate, 'dd/MM/yyyy')}
                </>
              ) : (
                'Selecionar datas'
              )}
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-auto p-4" align="start">
            <div className="space-y-4">
              <div>
                <label className="text-sm font-medium mb-2 block">Data Início</label>
                <Calendar
                  mode="single"
                  selected={customStartDate}
                  onSelect={setCustomStartDate}
                  locale={pt}
                  className="rounded-md border"
                />
              </div>
              <div>
                <label className="text-sm font-medium mb-2 block">Data Fim</label>
                <Calendar
                  mode="single"
                  selected={customEndDate}
                  onSelect={setCustomEndDate}
                  locale={pt}
                  className="rounded-md border"
                  disabled={(date) => customStartDate && date < customStartDate}
                />
              </div>
              <Button 
                onClick={handleCustomApply} 
                className="w-full"
                disabled={!customStartDate || !customEndDate}
              >
                Aplicar
              </Button>
            </div>
          </PopoverContent>
        </Popover>
      )}
    </div>
  );
};

export default PeriodFilter;
